import { render, staticRenderFns } from "./GlassesSvg.vue?vue&type=template&id=3753638e&scoped=true&"
import script from "./GlassesSvg.vue?vue&type=script&lang=js&"
export * from "./GlassesSvg.vue?vue&type=script&lang=js&"
import style0 from "./GlassesSvg.vue?vue&type=style&index=0&id=3753638e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753638e",
  null
  
)

export default component.exports